import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { FilteringRule } from 'features/globalSetup/types/filteringRule'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_FILTERING_RULE } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteFilteringRule, UseDeleteFilteringRuleProps } from './types'

export const useDeleteFilteringRule = ({
  name,
}: UseDeleteFilteringRuleProps): UseDeleteFilteringRule => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.protection.delete.action',
  })

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_FILTERING_RULE,
    onCompleted: async ({ errors }: Data): Promise<void> => {
      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error', { filteringRule: name }), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success', { filteringRule: name }), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['filteringRules'],
  })

  const deleteFilteringRule = (id: FilteringRule['id']): void => {
    mutateAsync({ input: { id } })
  }

  return { deleteFilteringRule }
}
